import {
  SET_NOTICE,
  GET_NOTICE,
  DELETE_NOTICE,
  UPDATE_NOTICE,
  GET_ONE_NOTICE,
  ADD_PHOTOS,
} from "./actionType";

export const setNotice = (notice) => {
  return {
    type: SET_NOTICE,
    payload: notice,
  };
};

export const getNotice = (noticeData) => {
  return {
    type: GET_NOTICE,
    payload: noticeData,
  };
};

export const deleteNotice = (id) => {
  return {
    type: DELETE_NOTICE,
    payload: id,
  };
};

export const updateNotice = (updatedNotice) => {
  return {
    type: UPDATE_NOTICE,
    payload: updatedNotice,
  };
};

export const getOneNotice = (noticeOneData) => {
  return {
    type: GET_ONE_NOTICE,
    payload: noticeOneData,
  };
};

export const deleteImage = (id, photo) => {
  return {
    type: DELETE_NOTICE,
    payload: { id, photo },
  };
};

export const addImage = (photo) => {
  return {
    type: ADD_PHOTOS,
    payload: photo,
  };
};
